module.exports = __webpack_public_path__ + "static/media/ringtone.31c99b54.mp3";